import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, GridItem, Typography } from '@coolblue-development/freddy';
export const Introduction = ({ content, isBasicHeader }) => {
    return (_jsx(Grid, { children: _jsx(GridItem, { column: isBasicHeader ? { xs: 'span 12', lg: 'span 8' } : 'span 12', children: _jsx(Typography, { variant: "intro", m: 0, children: content }) }) }));
};
//# sourceMappingURL=Introduction.js.map